var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"accordion",class:[
    { 'accordion--grey' : _vm.grey },
    { 'accordion--press' : _vm.press } ],attrs:{"data-accordion":"","data-allow-all-closed":"true","data-multi-expand":_vm.multiExpand}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }